import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import { Pagination } from "react-bootstrap";

const Products = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [productToUpdate, setProductToUpdate] = useState(null);
  const navigate = useNavigate();

  // Updateble data
  const [productId, setProductId] = useState();
  const [productTitle, setProductTitle] = useState();
  const [productPrice, setProductPrice] = useState();
  const [productSku, setProductSku] = useState();
  const [productStock, setProductStock] = useState();
  const [productDescription, setProductDescription] = useState();
  const [productStatus, setProductStatus] = useState("");
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [updatedsellingprice, setUpdatedsellingprice] = useState("");

  const [newSubcategory, setNewSubcategory] = useState("");
  const [orderstatus, setOrderstatus] = useState("");
  const [discount, setdiscount] = useState();
  const [days, setdays] = useState();
  const [commission, setcommission] = useState();
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [productTags, setProductTags] = useState({});

  const [brand, setBrand] = useState();
  const [size, setSize] = useState();
  const [colour, setColour] = useState();
  const [minqty, setminqty] = useState();
  const [unit, setUnit] = useState();
  const [pices, Setpices] = useState();
  const [gstId, SetgstId] = useState();

  const [updatehsncode, Setupdatehsncode] = useState(""); //after

  // -------------for calculate discount-------------
  const [Discount, setDiscount] = useState("");
  const [price, setPrice] = useState("");
  const [showsellingprice, setshowsellingprice] = useState("");

  // Authentication
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const getData = async (token) => {
    const response = await getProducts(token);
    setProductStatus(response?.status);
    // setProducts(response?.products?.myProducts)
    // setProducts(response?.products?.allProducts);
    setProducts(
      Array.isArray(response?.products?.allProducts)
        ? response?.products?.allProducts
        : []
    );
  };

  useEffect(() => {
    getData(token);
  }, [token]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setSelectedTags([]);
    setShow(true);
  };
  const handleUpdateClose = () => setShowUpdate(false);
  const handleDeleteClose = () => {
    setShowDelete(false);
    setProductId("");
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}product/categories`
        );
        setCategories(response.data.categories);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    getCategories();
  }, []);

  const getSubCategories = async (category) => {
    const categoryId = JSON.parse(category).id;
    const categoryName = JSON.parse(category).name;

    setSelectedCategory(categoryId);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/subcategories?categoryname=${categoryName}`
      );
      setSubCategories(response.data.subcategories);
    } catch (error) {
      console.error("Error: " + error);
    }
  };

  const handleImageClick = () => {
    document.getElementById("mainImageInput").click();
  };

  const [productData, setProductData] = useState({
    mainImage: null,
    productName: "",
    price: "",
    sku: "",
    stock: 1,
    description: "",
    discount: "",
    validDays: "",
    commission: "",
    selectBrand: "",
    size: "",
    minimumOrderQty: "",
    unit: "",
    pices: "",
    hsncode: "",
    gallery: [null, null, null],
  });

  const [updatedProductGallery, setUpdatedProductGallery] = useState({ gallery: [null, null, null, null] })

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    let totalDiscount = 0;
    let finalPrice = 0;

    if (name === "price") {
      setPrice(value);
      if (Discount) {
        totalDiscount = (parseInt(value) * parseInt(Discount)) / 100;
        finalPrice = value - totalDiscount;
        setshowsellingprice(Math.round(finalPrice));
      }
    } else if (name === "discount") {
      setDiscount(value);
      if (price) {
        totalDiscount = (parseInt(price) * parseInt(value)) / 100;
        finalPrice = price - totalDiscount;
        setshowsellingprice(Math.round(finalPrice));
      }
    }
    if (files) {
      setProductData({
        ...productData,
        [name]: files[0],
      });
    } else {
      setProductData({
        ...productData,
        [name]: value,
      });
    }
  };

  const handleGalleryChange = (index, file) => {
    const updatedGallery = [...productData.gallery];
    updatedGallery[index] = file;
    setProductData({
      ...productData,
      gallery: updatedGallery,
    });
  };

  const handleGalleryUpdate = (index, file) => {
    const updatedGallery = [...updatedProductGallery.gallery];
    updatedGallery[index] = { key: index, value: file };
    setUpdatedProductGallery({
      gallery: updatedGallery
    })
  }

  const [gst, setGst] = useState([]);

  useEffect(() => {
    fetchGstData();
  }, []);

  const fetchGstData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/getallgstdata`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const fetchedData = response.data.gst; // Access the 'gst' property from the response
      setGst(fetchedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    const images = [productData.mainImage, ...productData.gallery];

    const productPayload = {
      ...productData,
      tags: selectedTags.map((tag) => (tag.__isNew__ ? tag.label : tag.value)), // Handle new tags
    };

    images.forEach((file) => {
      if (file) {
        formData.append(`images`, file);
      }
    });

    if (
      productData.productName === "" ||
      productData.price === "" ||
      productData.sku === "" ||
      productData.description === "" ||
      productData.discount === "" ||
      productData.validDays === "" ||
      productData.commission === ""
    ) {
      toast.error("Please complete product details!");
      return;
    }

    if (!productData.validDays) {
      toast.error("Please select a valid expiration date!");
      return;
    }

    if (selectedCategory === "" && newSubcategory === "") {
      toast.warn("Select category and subcategory!");
      return;
    }

    if (!productData.selectBrand) {
      toast.error("Please select a Brand!");
      return;
    }
    if (!productData.size) {
      toast.error("Please select a size!");
      return;
    }
    if (!productData.colour) {
      toast.error("Please select a colour!");
      return;
    }
    if (!productData.minimumOrderQty) {
      toast.error("Please select minimumOrderQty!");
      return;
    }
    if (!productData.unit) {
      toast.error("Please select a unit!");
      return;
    }
    if (!productData.pices) {
      toast.error("Please select a unit!");
      return;
    }

    // upto_valid_days
    formData.append("title", productData.productName);
    formData.append("price", productData.price);
    formData.append("sku", productData.sku);
    formData.append("stockQty", productData.stock);
    formData.append("description", productData.description);
    formData.append("discount_percentage", productData.discount);
    formData.append("upto_valid_days", productData.validDays);
    formData.append("commission_per_product", productData.commission);
    formData.append("categories", selectedCategory);
    formData.append("subcategories", newSubcategory);
    formData.append("tags", JSON.stringify(productPayload.tags));

    formData.append("selectBrand", productData.selectBrand);
    formData.append("size", productData.size);
    formData.append("colour", productData.colour);
    formData.append("minimumOrderQty", productData.minimumOrderQty);
    formData.append("unit", productData.unit);
    formData.append("pices", productData.pices);
    formData.append("hsncode", productData.hsncode);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}product/add`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      const message = response.data.message;
      const status = response.data.status;

      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success("Product successfully uploaded");
        getData(token);
      }
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  useEffect(() => {
    const getAllTags = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}product/alltags`,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setTags(
          response.data.Alltags.map((tag) => ({
            value: tag.id,
            label: tag.tagname,
          }))
        );
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };

    getAllTags();
  }, [token]);

  useEffect(() => {
    if (productId) {
      getTagNames(productId);
    }
  }, [productId]); // Re-run when productId changes

  const getTagNames = async (productId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/tagname?productId=${productId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      // setTag(response?.data?.allTagsWithNames); // Update the tags state with the fetched data
      const fetchedTags = response?.data?.allTagsWithNames.map((tag) => ({
        label: tag.tagName,
        value: tag.tagId,
      }));

      // Update the productTags state with the tags for this product
      setProductTags((prevTags) => ({
        ...prevTags,
        [productId]: fetchedTags || [],
      }));
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  const handleTagChange = (selectedOptions, productId) => {
    setProductTags((prevTags) => ({
      ...prevTags,
      [productId]: selectedOptions,
    }));
    setSelectedTags(selectedOptions);
  };

  const handleDeleteShow = (productId) => {
    setProductId(productId);
    setShowDelete(true);
  };

  const [hsncode, setSelectedHsnCode] = useState("");

  useEffect(() => {
    if (productId) {
      fetchsnwithproductData(productId);
    }
  }, [productId]);

  const fetchsnwithproductData = async (productId) => {
    try {
      const queryParams = `productId=${productId}`;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/getproductwithhsn?${queryParams}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateShow = async (product) => {
    setProductToUpdate(product);
    setProductId(product.id);
    setProductTitle(product.title);
    setProductPrice(product.price);
    setProductSku(product.sku);
    setProductStock(product.stockQty);
    setProductDescription(product.description);
    setdiscount(product.discount);
    setdays(product.validDays);
    setcommission(product.commission);
    setUpdatedsellingprice(product.update_price);
    setBrand(product.selectBrand);
    setSize(product.size);
    setColour(product.colour);
    setminqty(product.minimumOrderQty);
    setUnit(product.unit);
    Setpices(product.pices);

    const hsnCodeFromGst =
      gst.find((item) => item.id === product.gstId)?.hsncode || "";
    setSelectedHsnCode(hsnCodeFromGst);

    SetgstId(product.gstId);

    setShowUpdate(true);
  };

  const handleHsnCodeChange = (e) => {
    const selectedHsnCode = e.target.value;
    setSelectedHsnCode(selectedHsnCode);
    const selectedGstId = gst.find(
      (item) => item.hsncode === selectedHsnCode
    )?.id;

    SetgstId(selectedGstId);
  };

  // On component mount, fetch the product details (if productId is provided)

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    // Validation block
    if (!productTitle?.trim()) return toast.error("Please enter product name");
    if (!productPrice) return toast.error("Please enter product MRP");
    if (!gstId) return toast.error("Please select a HSN code");
    if (!productSku?.trim()) return toast.error("Please enter product SKU");
    if (!productStock) return toast.error("Please enter at least one product in stock");
    if (!minqty) return toast.error("Please select minimum quantity of one");
    if (!brand) return toast.error("Please select a Brand");
    if (!unit) return toast.error("Please enter product unit");

    const formData = new FormData();
    const productPayload = {
      ...productData,
      tags: productTags[productId].map((tag) => (tag.__isNew__ ? tag.label : tag.value)), // Handle new tags
    };

    // Update logic goes here
    formData.append("id", productId);
    formData.append("title", productTitle);
    formData.append("price", productPrice);
    formData.append("sku", productSku);
    formData.append("stockQty", productStock);
    formData.append("description", productDescription);
    formData.append("discount_percentage", discount);
    formData.append("upto_valid_days", days);
    formData.append("commission_per_product", commission);

    formData.append("selectBrand", brand);
    formData.append("size", size);
    formData.append("colour", colour);
    formData.append("minimumOrderQty", minqty);
    formData.append("unit", unit);
    formData.append("pices", pices);
    formData.append("gstId", gstId);

    formData.append("tags", JSON.stringify(productPayload.tags));

    const imageKeyMap = [];

    updatedProductGallery.gallery.forEach((file) => {
      if (file) {
        formData.append(`images`, file.value);
        imageKeyMap.push(file.key);
      }
    })

    formData.append('imageKeys', JSON.stringify(imageKeyMap));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}product/update`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success("Product successfully updated");
        setSelectedHsnCode(response.data.product.hsncode);
        getData(token);
        galleryClean()
      }
    } catch (error) {
      toast.error("Error:", error);
    }

    handleUpdateClose();
  };


  const handleDeleteSubmit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}product/delete`,
        { id: productId },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const message = response.data.message;
      const status = response.data.status;

      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success(message);
        getData(token);
      }
    } catch (error) {
      toast.error("Error:", error);
    }

    handleDeleteClose();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "5px", // Adds padding inside the control
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0", // Remove padding inside the value container to avoid double padding
    }),
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6); // Define per page items (7 in your case)
  const [totalPages, setTotalPages] = useState(
    Math.ceil(products.length / itemsPerPage)
  ); // Total pages calculation

  useEffect(() => {
    setTotalPages(Math.ceil(products.length / itemsPerPage));
  }, [products, itemsPerPage]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const productShow = products.slice(indexOfFirstItem, indexOfLastItem);

  const renderPaginationItems = () => {
    const items = [];

    if (totalPages <= 5) {
      for (let number = 1; number <= totalPages; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === currentPage}
            onClick={() => handlePageClick(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
    } else {
      items.push(
        <Pagination.Item
          key={1}
          active={1 === currentPage}
          onClick={() => handlePageClick(1)}
        >
          1
        </Pagination.Item>
      );

      if (currentPage > 3) {
        items.push(<Pagination.Ellipsis key="left-ellipsis" disabled />);
      }

      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);
      for (let number = startPage; number <= endPage; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === currentPage}
            onClick={() => handlePageClick(number)}
          >
            {number}
          </Pagination.Item>
        );
      }

      if (currentPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="right-ellipsis" disabled />);
      }

      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  function galleryClean() {

    setUpdatedProductGallery(prev => ({
      ...prev,
      gallery: [null, null, null, null]
    }));
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 p-0">
            <Sidebar
              toggleSidebar={toggleValue}
              setToggleValue={setToggleValue}
            />
          </div>
          <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
            <Icon.ArrowRight
              onClick={() => setToggleValue(true)}
              className="my-5 sidebar-open"
              color="black"
              size={30}
            ></Icon.ArrowRight>
            <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
              <div className="col-12">
                <div className="row">
                  <div className="col-lg-10 col-md-8 col-6">

                    <h5>Products</h5>

                    {productShow?.length > 0 ? (
                      <h6 className="text-muted">View & manage products</h6>
                    ) : (
                      <h6 className="text-muted">No product uploaded yet</h6>
                    )}
                  </div>
                  <div className="col-lg-2 col-md-4 col-6 text-end">
                    <Button variant="success" onClick={handleShow}>
                      Add product
                      <Icon.PlusCircle className="ms-2" />
                    </Button>
                  </div>
                </div>
                <div className="mt-4">
                  <Table striped bordered hover responsive="md">
                    <thead className="text-center">
                      <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>SKU</th>
                        <th>MRP</th>
                        <th>Selling Price</th>
                        <th>Stock</th>
                        {/* <th>Sold</th> */}
                        <th>Actions</th>
                        {/* <th>orderType</th> */}
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productStatus === "success" ? (
                        productShow.map((product, i) => {
                          const id = (currentPage - 1) * itemsPerPage + i + 1;
                          return (
                            <tr key={i}>
                              {/* <td>{parseInt(i) + 1}</td> */}
                              <td>{id}</td>
                              <td>
                                <img
                                  className="order-list-product-image"
                                  src={`${product.image.length > 0
                                    ? process.env.REACT_APP_API_URL +
                                    process.env.REACT_APP_product_IMAGE_URL +
                                    product.image[0]
                                    : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"
                                    }`}
                                  alt=""
                                />
                              </td>
                              <td>{product.title}</td>
                              <td>{product.sku}</td>
                              <td><Icon.CurrencyRupee />{product.price}</td>
                              <td><Icon.CurrencyRupee />{product.update_price}</td>
                              <td>{product.stockQty}</td>
                              {/* <td>{product.orderQty}</td> */}
                              <td>
                                <button
                                  onClick={() => handleUpdateShow(product)}
                                  className="btn btn-sm btn-warning me-lg-3 me-md-0 me-0 mb-lg-0 mb-md-0 mb-3"
                                >
                                  <Icon.Pencil />
                                </button>
                                {product.id != 13 && (
                                  <button
                                    onClick={() => handleDeleteShow(product.id)}
                                    className="btn btn-sm btn-danger"
                                  >
                                    <Icon.Trash />
                                  </button>
                                )}
                              </td>
                              <td>
                                {product.id === 13 && (
                                  <span className="text-danger fw-bold">
                                    ★
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <td colSpan="8" className="text-center p-5">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination controls */}
                <div className='col-12 d-flex justify-content-center mt-2'>
                  <Pagination>
                    <Pagination.First
                      onClick={() => handlePageClick(1)}
                      disabled={currentPage === 1}
                    />
                    <Pagination.Prev
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    />
                    {renderPaginationItems()}
                    <Pagination.Next
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageClick(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
                {/* Pagination end */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Product Modal */}
      <Modal show={show} onHide={handleClose} size="xl">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton onClick={() => productData.mainImage = null}>
            <Modal.Title>
              <Icon.Bag color="black" size={40} />
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-lg-4 mb-lg-0 mb-md-3 mb-3">
                <div
                  className="image-wrapper rounded p-2"
                  onClick={handleImageClick}
                >
                  <img
                    src={
                      productData.mainImage
                        ? URL.createObjectURL(productData.mainImage)
                        : `${process.env.PUBLIC_URL}/assets/dummy.png`
                    }
                    className="product-image w-100"
                    alt=""
                  />
                  <input
                    type="file"
                    id="mainImageInput"
                    className="d-none"
                    name="mainImage"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-lg-8">
                <FloatingLabel
                  controlId="floatingInput"
                  label={
                    <>
                      Product Name <span className="text-danger">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    className="shadow-none"
                    placeholder="product name"
                    name="productName"
                    value={productData.productName}
                    onChange={handleInputChange}
                  />
                </FloatingLabel>
                <Row className="">
                  <Col md={6} sm={12}>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="price">
                        MRP
                        <span className="text-danger">*</span>
                        <Icon.CurrencyRupee />
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="Price"
                        aria-describedby="price"
                        className="shadow-none"
                        name="price"
                        value={productData.price}
                        onChange={handleInputChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingHsnCode">
                      <InputGroup>
                        <InputGroup.Text
                          id="hsncode"
                          className="skucssdiscount fs-6"
                        >
                          HSN CODE
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Select
                          className="shadow-none"
                          name="hsncode"
                          onChange={handleInputChange}
                          value={productData.hsncode}
                        >
                          <option value="">HSN</option>
                          {gst.map((item) => (
                            <option key={item.id} value={item.hsncode}>
                              {item.hsncode}
                            </option>
                          ))}
                        </Form.Select>
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row className="">
                  <Col md={6} sm={12}>
                    <FloatingLabel
                      controlId="floatingDiscount"
                      label=""
                      className="mb-3"
                    >
                      <InputGroup>
                        <InputGroup.Text
                          id="discount"
                          className="skucssdiscount"
                        >
                          Dis%
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={productData.discount}
                          className="shadow-none"
                          placeholder="Dis"
                          name="discount"
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          step={0.01}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} sm={12}>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="price">
                        Selling
                        <Icon.CurrencyRupee />
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="Price"
                        aria-describedby="price"
                        className="shadow-none"
                        name="price"
                        defaultValue={
                          showsellingprice == NaN ? "price" : showsellingprice
                        }
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={6} sm={12}>
                    <FloatingLabel controlId="floatingInput" label="">
                      <InputGroup>
                        <InputGroup.Text id="stock">
                          Stock
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={productData.stock}
                          className="shadow-none"
                          placeholder="Stock"
                          name="stock"
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          step={1}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <FloatingLabel controlId="floatingInput" label="">
                      <InputGroup>
                        <InputGroup.Text id="sku" className="skucss">
                          SKU
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          className="shadow-none"
                          placeholder="SKU"
                          name="sku"
                          value={productData.sku}
                          onChange={handleInputChange}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <FloatingLabel controlId="floatingValidUpto" label="">
                      <InputGroup>
                        <InputGroup.Text
                          id="validupto"
                          className="skucssdiscount"
                        >
                          Size
                        </InputGroup.Text>
                        <Form.Control
                          className="shadow-none"
                          placeholder="size"
                          name="size"
                          value={productData.size}
                          onChange={handleInputChange}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                </Row>

                {/* -------------------------------------------------------------- */}
                <Row className="mb-3">
                  {/* <Col lg={4} md={6} sm={12}>
                    <FloatingLabel controlId="floatingDiscount" label="" className="mb-3">
                      <InputGroup>
                        <InputGroup.Text id="discount" className="skucssdiscount">Dis%</InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={productData.discount}
                          className="shadow-none"
                          placeholder="Dis"
                          name="discount"
                          onChange={handleInputChange}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col> */}
                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingMinQty" label="">
                      <InputGroup>
                        <InputGroup.Text id="minQty" className="skucssdiscount">
                          MinQty
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          className="shadow-none"
                          placeholder="qty"
                          name="minimumOrderQty"
                          value={productData.minimumOrderQty}
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          step={1}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>

                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingCommission" label="">
                      <InputGroup>
                        <InputGroup.Text
                          id="commission"
                          className="skucssdiscount"
                        >
                          Comm%
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={productData.commission}
                          className="shadow-none"
                          placeholder="Comm"
                          name="commission"
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          step={0.01}
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                </Row>
                {/* -------------------------------------------------------------- */}

                {/* ---------------------------------------------------------------------------------- */}
                <Row className="mb-3">
                  {/* Brand Dropdown */}
                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingBrand" label="">
                      <InputGroup>
                        <InputGroup.Text id="brand" className="skucssdiscount">
                          Brand
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Select
                          className="shadow-none"
                          name="selectBrand"
                          value={productData.selectBrand}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Brand</option>
                          <option value="Brand A">Brand A</option>
                          <option value="Brand B">Brand B</option>
                          <option value="Brand C">Brand C</option>
                        </Form.Select>
                      </InputGroup>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingValidUntil" label="">
                      <InputGroup>
                        <InputGroup.Text id="" className="skucssdiscount">
                          Exp
                        </InputGroup.Text>
                        <Form.Control
                          type="date"
                          value={productData.validDays} // Use validUntil for the date
                          className="shadow-none"
                          // name="validUntil" // Update the name to validUntil
                          name="validDays"
                          onChange={handleInputChange} // Handles the input change
                        />
                      </InputGroup>
                    </FloatingLabel>
                  </Col>

                  {/* Size (Date Input) */}

                  {/* Colour Dropdown */}
                </Row>
                <Row className="mb-3">
                  <Col md={6} sm={12}>
                    <FloatingLabel controlId="floatingColour" label="">
                      <InputGroup>
                        <InputGroup.Text id="colour" className="skucssdiscount">
                          Colour
                        </InputGroup.Text>
                        <Form.Select
                          className="shadow-none"
                          name="colour"
                          value={productData.colour}
                          onChange={handleInputChange}
                        >
                          <option value="">Colour</option>
                          <option value="Red">Red</option>
                          <option value="Blue">Blue</option>
                          <option value="Green">Green</option>
                          <option value="Yellow">Yellow</option>
                        </Form.Select>
                      </InputGroup>
                    </FloatingLabel>
                  </Col>

                  {/* Unit Dropdown */}
                  <Col md={6} sm={12}>
                    <FloatingLabel
                      controlId="floatingUnit"
                      label=""
                      className="mb-3"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0px",
                          width: "15",
                        }}
                      >
                        {/* Label */}
                        <InputGroup.Text id="unit" className="skucssdiscount">
                          Unit
                          <span className="text-danger">*</span>
                        </InputGroup.Text>

                        {/* Input Field */}
                        <Form.Control
                          type="number"
                          className="shadow-none"
                          placeholder="unit"
                          name="unit"
                          value={productData.unit}
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          step={1}
                          style={{
                            flex: 2, // Wider input box
                            borderTopLeftRadius: "10",
                            borderBottomLeftRadius: "10",
                          }}
                        />

                        {/* Dropdown */}
                        <Form.Select
                          className="shadow-none"
                          name="pices"
                          value={productData.pices}
                          onChange={handleInputChange}
                          style={{
                            flex: 1,
                            borderTopLeftRadius: "30",
                          }}
                        >
                          <option value="">Unit</option>
                          <option value="kg">kg</option>
                          <option value="gm">gm</option>
                          <option value="pcs">pcs</option>
                        </Form.Select>
                      </div>
                    </FloatingLabel>
                  </Col>
                </Row>
                {/*-------------------------------------------------------------------------------------- */}
              </div>
              <div className="col-12 mb-3">
                <FloatingLabel controlId="floatingTextarea2">
                  <CKEditor
                    editor={ClassicEditor}
                    data={productData.description}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      handleInputChange({
                        target: {
                          name: "description",
                          value: data,
                        },
                      });
                    }}
                    config={{
                      // Add any additional configuration if required
                      placeholder: "Enter product description...",
                    }}
                  />
                </FloatingLabel>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-lg-6">
                    <Form.Select
                      aria-label="Default select example"
                      onChange={(e) => getSubCategories(e.target.value)}
                    >
                      <option selected disabled>
                        Select a category
                      </option>
                      {categories.map((category) => (
                        <option
                          key={category.id}
                          value={JSON.stringify(category)}
                        >
                          {category.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="col-lg-6">
                    <Form.Select
                      aria-label="Default select example"
                      onChange={(e) => setNewSubcategory(e.target.value)}
                    >
                      <option selected disabled>
                        Select a Subcategory
                      </option>
                      {selectedCategory === "" ? (
                        <option className="text-muted" disabled>
                          Select a category first
                        </option>
                      ) : (
                        subCategories.map((subcategory, i) => (
                          <option
                            key={i}
                            value={subcategory.id}
                            className="d-flex justify-content-between"
                          >
                            {subcategory.name}
                          </option>
                        ))
                      )}
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="row mx-0 mt-3 border-top border-1">
                <p className="text-muted mt-2">Gallery</p>
                <div className="col-lg-4">
                  <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>1st image</Form.Label>
                    <Form.Control
                      type="file"
                      size="sm"
                      className="shadow-none"
                      onChange={(e) =>
                        handleGalleryChange(0, e.target.files[0])
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-lg-4">
                  <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>2nd image</Form.Label>
                    <Form.Control
                      type="file"
                      size="sm"
                      className="shadow-none"
                      onChange={(e) =>
                        handleGalleryChange(1, e.target.files[0])
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-lg-4">
                  <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>3rd image</Form.Label>
                    <Form.Control
                      type="file"
                      size="sm"
                      className="shadow-none"
                      onChange={(e) =>
                        handleGalleryChange(2, e.target.files[0])
                      }
                    />
                  </Form.Group>
                </div>

                <div className="mb-3">
                  {/* Tags Dropdown with Typing */}
                  Tags<span className="text-danger">*</span>
                  <CreatableSelect
                    isMulti
                    options={tags}
                    value={selectedTags}
                    // onChange={setSelectedTags}
                    onChange={handleTagChange}
                    placeholder="Choose or type tags..."
                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                    styles={customStyles} // Apply custom styles
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="">
            <Button
              variant="success"
              type="submit"
              className="shadow-none"
              onClick={handleClose}
            >
              Add product
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Update Product Modal */}
      <Modal show={showUpdate} onHide={handleUpdateClose} size="xl">
        <form onSubmit={handleUpdateSubmit}>
          <Modal.Header closeButton onClick={() => galleryClean()}>
          </Modal.Header>
          <Modal.Body>
            {productToUpdate && (
              <div className="row">
                <div className="col-lg-4 mb-lg-0 mb-md-3 mb-3">
                  <div className="image-wrapper rounded p-2 mb-3">
                    <div
                      className="image-wrapper rounded p-2"
                      onClick={handleImageClick}
                    >
                      <img
                        src={
                          updatedProductGallery.gallery[0]
                            ? URL.createObjectURL(updatedProductGallery.gallery[0].value)
                            : process.env.REACT_APP_API_URL + process.env.REACT_APP_product_IMAGE_URL + productToUpdate.image[0]
                        }
                        className="product-image w-100"
                        alt=""
                      />
                      <input
                        type="file"
                        id="mainImageInput"
                        className="d-none"
                        name="mainImage"
                        onChange={(e) =>
                          handleGalleryUpdate(0, e.target.files[0])
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <FloatingLabel
                    controlId="floatingInput"
                    label={
                      <>
                        Product Name <span className="text-danger">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      className="shadow-none"
                      placeholder="product name"
                      name="productName"
                      defaultValue={productToUpdate.title}
                      onChange={(e) => setProductTitle(e.target.value)}
                    />
                  </FloatingLabel>
                  <Row className="">
                    <Col md={6} sm={12}>
                      <InputGroup className="mb-3">
                        <InputGroup.Text id="price">
                          MRP
                          <Icon.CurrencyRupee />
                          <span className="text-danger">*</span>
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Price"
                          aria-describedby="price"
                          className="shadow-none"
                          name="price"
                          defaultValue={productToUpdate.price}
                          onChange={(e) => setProductPrice(e.target.value)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={6} sm={12}>
                      <FloatingLabel
                        controlId="floatingHsnCode"
                        className="mb-3"
                      >
                        <InputGroup>
                          <InputGroup.Text
                            id="hsncode"
                            className="skucssdiscount"
                          >
                            HSN CODE
                            <span className="text-danger">*</span>
                          </InputGroup.Text>
                          <Form.Select
                            className="shadow-none"
                            name="hsncode"
                            value={hsncode || ""} // Use the selected hsncode, fallback to empty string if not set
                            onChange={handleHsnCodeChange}
                          >
                            <option value="">Select a code</option>
                            {gst.map((item) => (
                              <option key={item.id} value={item.hsncode}>
                                {item.hsncode}
                              </option>
                            ))}
                          </Form.Select>
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col md={6} sm={12}>
                      <FloatingLabel
                        controlId="floatingDiscount"
                        label=""
                        className="mb-3"
                      >
                        <InputGroup>
                          <InputGroup.Text
                            id="discount"
                            className="skucssdiscount"
                          >
                            Dis%
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            defaultValue={
                              productToUpdate?.discount_percentage
                                ? productToUpdate?.discount_percentage
                                : ""
                            }
                            className="shadow-none"
                            placeholder="Dis"
                            name="discount"
                            onChange={(e) => setdiscount(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            min={0}
                            step={0.01} // Allows fractional percentage values
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    <Col md={6} sm={12}>
                      <InputGroup className="mb-3">
                        <InputGroup.Text id="price">
                          Selling
                          <Icon.CurrencyRupee />
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Price"
                          aria-describedby="price"
                          className="shadow-none"
                          name="price"
                          defaultValue={
                            updatedsellingprice ? updatedsellingprice : ""
                          }
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col lg={4} md={6} sm={12}>
                      <FloatingLabel controlId="floatingInput" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text id="stock">
                            Stock
                            <span className="text-danger">*</span>
                          </InputGroup.Text>

                          <Form.Control
                            type="number"
                            defaultValue={productToUpdate.stockQty}
                            className="shadow-none"
                            placeholder="Stock"
                            name="stock"
                            onChange={(e) => setProductStock(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            min={0}
                            step={1}
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <FloatingLabel controlId="floatingInput" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text id="sku" className="skucss">
                            SKU
                            <span className="text-danger">*</span>
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            className="shadow-none"
                            placeholder="SKU"
                            name="sku"
                            defaultValue={productToUpdate.sku}
                            onChange={(e) => setProductSku(e.target.value)}
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <FloatingLabel
                        controlId="floatingValidUpto"
                        label=""
                        className="mb-3"
                      >
                        <InputGroup>
                          <InputGroup.Text
                            id="validupto"
                            className="skucssdiscount"
                          >
                            Size
                          </InputGroup.Text>
                          <Form.Control
                            defaultValue={
                              productToUpdate?.size ? productToUpdate.size : ""
                            }
                            className="shadow-none"
                            placeholder="size"
                            name="size"
                            onChange={(e) => setSize(e.target.value)}
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row>
                    {/* MinQty */}
                    <Col md={6} sm={12}>
                      <FloatingLabel controlId="floatingMinQty" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text
                            id="minQty"
                            className="skucssdiscount"
                          >
                            MinQty
                            <span className="text-danger">*</span>
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            defaultValue={
                              productToUpdate?.minimumOrderQty
                                ? productToUpdate.minimumOrderQty
                                : ""
                            }
                            className="shadow-none"
                            placeholder="qty"
                            name="minqty"
                            onChange={(e) => setminqty(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            min={0}
                            step={1}
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    <Col md={6} sm={12}>
                      <FloatingLabel controlId="floatingCommission" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text
                            id="commission"
                            className="skucssdiscount"
                          >
                            Comm%
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            defaultValue={
                              productToUpdate?.commission_per_product
                                ? productToUpdate.commission_per_product
                                : ""
                            }
                            className="shadow-none"
                            placeholder="Comm"
                            name="commission"
                            onChange={(e) => setcommission(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            min={0}
                            step={0.1} // Allows fractional percentage values
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  {/* ------------------------------------------------------------------ */}
                  <Row>
                    <Col md={6} sm={12}>
                      <FloatingLabel controlId="floatingBrand" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text
                            id="brand"
                            className="skucssdiscount"
                          >
                            Brand
                            <span className="text-danger">*</span>
                          </InputGroup.Text>
                          <Form.Select
                            className="shadow-none"
                            name="brand"
                            onChange={(e) => setBrand(e.target.value)}
                            defaultValue={
                              productToUpdate?.selectBrand
                                ? productToUpdate.selectBrand
                                : ""
                            }
                          >
                            <option value="">Select Brand</option>
                            <option value="Brand A">Brand A</option>
                            <option value="Brand B">Brand B</option>
                            <option value="Brand C">Brand C</option>
                          </Form.Select>
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    <Col md={6} sm={12}>
                      <FloatingLabel controlId="floatingValidUpto" label="">
                        <InputGroup className="mb-3">
                          <InputGroup.Text
                            id="validupto"
                            className="skucssdiscount"
                          >
                            Exp
                          </InputGroup.Text>
                          <Form.Control
                            // type="number"
                            type="date"
                            defaultValue={
                              productToUpdate?.upto_valid_days
                                ? productToUpdate.upto_valid_days
                                : ""
                            }
                            className="shadow-none"
                            placeholder="Days"
                            name="validDays"
                            onChange={(e) => setdays(e.target.value)}
                            min={0}
                          />
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  {/*----------------------------------------------------------- */}
                  <Row>
                    {/* Colour Dropdown */}
                    <Col md={6} sm={12}>
                      <FloatingLabel
                        controlId="floatingColour"
                        label=""
                        className="mb-3"
                      >
                        <InputGroup>
                          <InputGroup.Text
                            id="colour"
                            className="skucssdiscount"
                          >
                            Colour
                          </InputGroup.Text>
                          <Form.Select
                            className="shadow-none"
                            name="colour"
                            onChange={(e) => setColour(e.target.value)}
                            defaultValue={
                              productToUpdate?.colour
                                ? productToUpdate.colour
                                : ""
                            }
                          >
                            <option value="">Select Colour</option>
                            <option value="Red">Red</option>
                            <option value="Blue">Blue</option>
                            <option value="Green">Green</option>
                            <option value="Yellow">Yellow</option>
                          </Form.Select>
                        </InputGroup>
                      </FloatingLabel>
                    </Col>
                    {/* Unit Dropdown */}
                    <Col md={6} sm={12}>
                      <FloatingLabel
                        controlId="floatingUnit"
                        label=""
                        className="mb-3"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                          }}
                        >
                          {/* Label */}
                          <InputGroup.Text id="unit" className="skucssdiscount">
                            Unit
                            <span className="text-danger">*</span>
                          </InputGroup.Text>

                          {/* Input Field */}
                          <Form.Control
                            type="number"
                            defaultValue={
                              productToUpdate?.unit ? productToUpdate.unit : ""
                            }
                            className="shadow-none"
                            placeholder="unit"
                            name="unit"
                            onChange={(e) => setUnit(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            min={0}
                            step={1}
                            style={{
                              flex: 2, // Wider input box
                              borderTopLeftRadius: "10",
                              borderBottomLeftRadius: "10",
                            }}
                          />

                          {/* Dropdown */}
                          <Form.Select
                            className="shadow-none"
                            name="unit"
                            onChange={(e) => Setpices(e.target.value)}
                            defaultValue={
                              productToUpdate.pices ? productToUpdate.pices : ""
                            }
                            style={{
                              flex: 1,
                              borderTopLeftRadius: "30",
                            }}
                          >
                            <option value="">SelectUnit</option>
                            <option value="kg">kg</option>
                            <option value="gm">gm</option>
                            <option value="pcs">pcs</option>
                          </Form.Select>
                        </div>
                      </FloatingLabel>
                    </Col>
                  </Row>

                  {/*----------------------------------------------------------- */}
                </div>
                <div className="col-12">
                  {/* <FloatingLabel controlId="floatingTextarea2" label="Description"> */}
                  <FloatingLabel controlId="floatingTextarea2">
                    <Form.Group className="col-12 mb-3">
                      <CKEditor
                        editor={ClassicEditor}
                        data={productToUpdate.description}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setProductDescription(data);
                        }}
                        config={{
                          placeholder: "Enter product description...",
                        }}
                      />
                    </Form.Group>
                  </FloatingLabel>
                  <div className="row mx-0 mt-3 border-top border-1">
                    <p className="text-muted mt-2">Gallery</p>
                    <div className="col-lg-4">
                      <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>1st image</Form.Label>
                        <img
                          src={
                            productToUpdate.image[1]
                              ?
                              process.env.REACT_APP_API_URL + process.env.REACT_APP_product_IMAGE_URL + productToUpdate.image[1]
                              :
                              `${process.env.PUBLIC_URL}/assets/dummy.png`
                          }
                          alt=""
                          style={{ height: "70px", width: "70px", objectFit: "contain" }}
                          className="border border-secondary border-1 rounded form-control mb-2"
                        />
                        <Form.Control
                          type="file"
                          size="sm"
                          className="shadow-none"
                          onChange={(e) =>
                            handleGalleryUpdate(1, e.target.files[0])
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-4 position-relative">
                      {
                        !productToUpdate.image[1] && !updatedProductGallery.gallery[1] &&
                        <div
                          className="overlay border border-1 border-white"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.31)',
                            backdropFilter: 'blur(5px)',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 2,
                            borderRadius: '0.375rem',
                            fontWeight: 'bold',
                            fontSize: '14px',
                          }}
                        >
                          Enter previous image to unlock
                        </div>
                      }
                      <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>2nd image</Form.Label>
                        <img
                          src={
                            productToUpdate.image[2]
                              ?
                              process.env.REACT_APP_API_URL + process.env.REACT_APP_product_IMAGE_URL + productToUpdate.image[2]
                              :
                              `${process.env.PUBLIC_URL}/assets/dummy.png`
                          }
                          alt=""
                          style={{ height: "70px", width: "70px", objectFit: "contain" }}
                          className="border border-secondary border-1 rounded form-control mb-2"
                        />
                        <Form.Control
                          type="file"
                          size="sm"
                          className="shadow-none"
                          onChange={(e) =>
                            handleGalleryUpdate(2, e.target.files[0])
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-4 position-relative">
                      {
                        !productToUpdate.image[2] && !updatedProductGallery.gallery[2] &&
                        <div
                          className="overlay"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.31)',
                            backdropFilter: 'blur(5px)',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 2,
                            borderRadius: '0.375rem',
                            fontWeight: 'bold',
                            fontSize: '14px',
                          }}
                        >
                          Enter previous image to unlock
                        </div>
                      }
                      <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>3rd image</Form.Label>
                        <img
                          src={
                            productToUpdate.image[3]
                              ?
                              process.env.REACT_APP_API_URL + process.env.REACT_APP_product_IMAGE_URL + productToUpdate.image[3]
                              :
                              `${process.env.PUBLIC_URL}/assets/dummy.png`
                          }
                          alt=""
                          style={{ height: "70px", width: "70px", objectFit: "contain" }}
                          className="border border-secondary border-1 rounded form-control mb-2"
                        />
                        <Form.Control
                          type="file"
                          size="sm"
                          className="shadow-none"
                          onChange={(e) =>
                            handleGalleryUpdate(3, e.target.files[0])
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="mb-3">
                      {/* Tags Dropdown with Typing */}
                      Tags<span className="text-danger">*</span>
                      <CreatableSelect
                        isMulti
                        options={tags} // All available tags
                        value={productTags[productToUpdate.id] || []} // Tags specific to the current product
                        onChange={(selectedOptions) =>
                          handleTagChange(selectedOptions, productToUpdate.id)
                        }
                        placeholder="Choose or type tags..."
                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`} // Format for creating new tags
                        styles={customStyles} // Apply custom styles
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="">
            <Button variant="success" type="submit" className="shadow-none">
              Update product
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Delete Product Modal */}
      <Modal show={showDelete} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Icon.Trash3 color="black" size={40} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container p-3 text-center">
            <h5>Are you sure to delete this product?</h5>
            <button
              onClick={handleDeleteSubmit}
              className="btn btn-danger mt-3"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer theme="dark" autoClose={2000} />
    </>
  );
};

export default Products;

export const getProducts = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}product/`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};
